"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Splash = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactTransitionGroup = require("react-transition-group");

require("./index.scss");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Node
// Style
var Splash = function Splash(_ref) {
  var children = _ref.children,
      style = _ref.style,
      className = _ref.className,
      visible = _ref.visible,
      timeout = _ref.timeout,
      transitionClassName = _ref.transitionClassName;
  return /*#__PURE__*/_react.default.createElement(_reactTransitionGroup.CSSTransition, {
    in: visible,
    timeout: timeout,
    classNames: transitionClassName,
    unmountOnExit: true
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "shpmtc-splash ".concat(className),
    style: style
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "shpmtc-splash__center-box"
  }, children)));
}; // Prop Types


exports.Splash = Splash;
Splash.defaultProps = {
  children: null,
  style: null,
  className: null,
  visible: null,
  timeout: 1000,
  transitionClassName: 'splash-fade'
};
Splash.propTypes = {
  children: _propTypes.default.node,
  style: _propTypes.default.instanceOf(Object),
  className: _propTypes.default.string,
  visible: _propTypes.default.bool,
  timeout: _propTypes.default.number,
  transitionClassName: _propTypes.default.string
};